import { memo } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledDDHeader, StyledText } from "./styles";

const DropdownHeader = () => {
    return (
        <StyledDDHeader>
            <I18n
                data-automation="country-column-text"
                element={StyledText}
                translatable={{ key: "global.country" }}
            />
            <I18n
                data-automation="employees-column-text"
                element={StyledText}
                translatable={{
                    key: "si.account-overview.employee-location.dropdown.employees-column",
                }}
            />
        </StyledDDHeader>
    );
};

export default memo(DropdownHeader);
